import React from 'react';
import mastercard from '../assets/mastercard.png';
import visa from '../assets/visa.png';

const CardIcons: any = {
    Mastercard: (
        <img
            alt="Credit Card Logos"
            title="Credit Card Logos"
            src={mastercard}
            width="35"
            height="20"
        />
    ),
    Visa: (
        <img alt="Credit Card Logos" title="Credit Card Logos" src={visa} width="35" height="20" />
    ),
    Amex: (
        <img
            alt="Credit Card Logos"
            title="Credit Card Logos"
            src="http://www.credit-card-logos.com/images/american_express_credit-card-logos/american_express_logo_3.gif"
            width="22"
            height="22"
        />
    ),
    Discover: (
        <img
            alt="Credit Card Logos"
            title="Credit Card Logos"
            src="http://www.credit-card-logos.com/images/discover_credit-card-logos/discover_logo_3.gif"
            width="32"
            height="22"
        />
    ),
};

export default CardIcons;
